import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { baseUrl } from "../../config/baseUrl";
import MultiSelectDropdown from "./multi-select-dropdown";
import { Bounce, toast } from "react-toastify";

export const EduUsersEditAdmin = ({
  userType,
  forceUpdate,
  setForceUpdate,
  activateEduUserEdit,
  setActivateEduUserEdit,
  userData,
  setUserData,
  editUserType,
}) => {
  const {
    campus_details,
    country_code,
    email,
    first_name,
    last_name,
    mobile,
    user_type,
    username,
    id,
    edu_company,
  } = userData;

  const [firstName, setFirstName] = useState(first_name || "");
  const [lastName, setLastName] = useState(last_name || "");
  const [password, setPassword] = useState("");
  const [userMobile, setUserMobile] = useState(mobile || "");
  const [userEmail, setUserEmail] = useState(email || "");
  const [userName, setUserName] = useState(username || "");
  const [campusId, setCampusId] = useState([]); // Empty array for multiple selections
  const [countryCode, setCountryCode] = useState(country_code || ""); // Or default to "91" if needed
  const [userTypeSelect, setUserTypeSelect] = useState(user_type || "");
  const [campusList, setCampusList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState(
    edu_company ? Number(edu_company) : null
  );
  const selectedCompanyName = companyList.find((m) => m.id === selectedCompany);


  const getCampusList = async () => {
    let response = await axios(`${baseUrl}/get_campus/`, {
      method: "GET",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    });
    setCampusList(
      response?.data?.data?.map((m) => ({
        id: m?.id,
        campus_name: m?.campus_name,
      }))
    );
  };

  const getCompanyList = async () => {
    let response = await axios(`${baseUrl}/list_get_company/`, {
      method: "GET",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    });
    setCompanyList(response?.data?.data || []);
  };

  const arraysEqual = (a, b) => {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    // Check each element (assuming order matters)
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchData = {
      ...(firstName !== first_name ? { first_name: firstName } : {}),
      ...(lastName !== last_name ? { last_name: lastName } : {}),
      ...(userMobile !== mobile ? { mobile: userMobile } : {}),
      ...(userEmail !== email ? { email: userEmail } : {}),
      ...(userName !== username ? { username: userName } : {}),
      ...(!arraysEqual(campusId, campus_details || [])
        ? { campus: campusId }
        : {}),
      ...(countryCode !== country_code ? { country_code: countryCode } : {}),
      ...(userTypeSelect !== user_type ? { user_type: userTypeSelect } : {}),
      ...(selectedCompany !== (edu_company ? Number(edu_company) : null)
        ? { edu_company: selectedCompany }
        : {}),
    };
    let response;
    try {
      response = await axios(`${baseUrl}/update_user_manager/${id}/`, {
        method: "PATCH",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...patchData },
      });
      if (response?.status === 200) {
        let unique = document.getElementById("edu-users-edit-admin-modal");
        if (unique) {
          unique.click();
        }
        setActivateEduUserEdit(false);
        setForceUpdate(!forceUpdate);
        toast.success("Admin updated Successfully!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (activateEduUserEdit && editUserType === "admin") {
      (async function () {
        await getCampusList();
        await getCompanyList();
      })();
    }
  }, [activateEduUserEdit, editUserType]);

  useEffect(() => {
    if (activateEduUserEdit) {
      setFirstName(first_name || "");
      setLastName(last_name || "");
      setPassword("");
      setUserMobile(mobile || "");
      setUserEmail(email || "");
      setUserName(username || "");
      setCampusId([...campus_details?.map((m) => m?.id)]); // Empty array for multiple selections
      setCountryCode(country_code || ""); // Or default to "91" if needed
      setUserTypeSelect(user_type || "");
      setSelectedCompany(edu_company ? Number(edu_company) : null);
    }
  }, [activateEduUserEdit, userData]);

  return (
    <div
      className="modal fade custom-modal users-modal"
      id="edit-admin-modal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Modify Admin</h5>
            <button
              type="button"
              className="modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="edu-users-edit-admin-modal"
              onClick={() => {
                setActivateEduUserEdit(false);
              }}
            >
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-body">
            <div className="table modal-table">
              <div className="d-flex flex-column gap-3 p-3">
                {/* Row 1 */}
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-grow-1">
                    <label className="form-label">
                      First Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First name"
                      name="first_name"
                      onChange={(e) => setFirstName(e.target.value)}
                      value={firstName}
                    />
                  </div>

                  <div className="flex-grow-1">
                    <label className="form-label">
                      Last Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                      name="last_name"
                      onChange={(e) => setLastName(e.target.value)}
                      value={lastName}
                    />
                  </div>

                  <div className="flex-grow-1">
                    <label className="form-label">
                      Email <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      onChange={(e) => setUserEmail(e.target.value)}
                      value={userEmail}
                      id="email"
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-grow-1">
                    <label className="form-label">
                      User Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="username"
                      name="username"
                      onChange={(e) => setUserName(e.target.value)}
                      value={userName}
                      id="username"
                    />
                  </div>

                  <div className="flex-grow-1">
                    <label className="form-label">Mobile Number</label>
                    <PhoneInput
                      name="mobile"
                      value={countryCode + userMobile}
                      placeholder="Mobile number"
                      country={"in"}
                      onChange={(phone) => setUserMobile(phone)}
                    />
                  </div>
                </div>

                {/* Row 3 - Company */}
                <div className="d-flex flex-wrap gap-3">
                  <div className="flex-grow-1">
                    <label className="form-label">
                      Company <i className="fa fa-star fz-12" />
                    </label>
                    <select
                      name="company"
                      onChange={(e) =>
                        setSelectedCompany(Number(e.target.value))
                      }
                      className="form-select"
                      value={selectedCompany}
                    >
                      <option value="">Select Company</option>
                      {companyList.map((comp) => (
                        <option key={comp.id} value={comp.id}>
                          {comp.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-5"
              data-bs-dismiss="modal"
              id="unique"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="thm-btn"
              // data-bs-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
